export const MIN_FILTER_LENGTH = 3;
export const DEBOUNCE_DELAY = 500;
export const DEFAULT_PLACEHOLDER = "Type to search...";
export const ERROR_MESSAGE = "Error fetching data. Please try again.";
export const MIN_CHAR_MESSAGE = "Type more characters to search";
export const NO_RESULTS_MESSAGE = "No results found";
export const LOADING_MESSAGE = "Loading...";
export const DEFAULT_QUERY_ARGS = {};
